var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStarIcon = function SvgStarIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2065 1.63397C19.9402 0.147483 22.0598 0.14748 22.7935 1.63397L27.5881 11.3489C27.8794 11.9392 28.4425 12.3483 29.094 12.443L39.815 14.0009C41.4555 14.2392 42.1105 16.2552 40.9235 17.4122L33.1656 24.9743C32.6942 25.4337 32.4791 26.0957 32.5904 26.7445L34.4218 37.4223C34.702 39.0561 32.9872 40.302 31.5199 39.5306L21.9307 34.4893C21.348 34.183 20.652 34.183 20.0693 34.4893L10.4801 39.5306C9.01285 40.302 7.29798 39.0561 7.5782 37.4223L9.40958 26.7445C9.52085 26.0957 9.30576 25.4337 8.83438 24.9743L1.07655 17.4122C-0.110488 16.2552 0.54453 14.2392 2.18497 14.0009L12.906 12.443C13.5575 12.3483 14.1206 11.9392 14.4119 11.3489L19.2065 1.63397Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStarIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "star-icon.66b1aedd1f0c190c9e1624d0be1a3a48.svg";